<div class="container">
      <sca-module-title class="title-test">
    <h1>Valid Forms Playground</h1>
    <span scaModuleTitlePost>Librería @argo/validation - Validación de formularios - 100% cobertura</span>
  </sca-module-title>
  <section class="card">
        <h2>Formulario de Tests</h2>
       <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="input-container">
             <sca-text-field label="Email">
              <input id="email" scaNativeControl type="text" formControlName="email" />
            </sca-text-field>
            <div *ngIf="form.controls['email'].touched && form.controls['email'].invalid">
                <span class="error" *ngIf="form.controls['email'].errors?.['required']">Email requerido</span>
                <span class="error" *ngIf="form.controls['email'].errors?.['emailInvalido']">Email inválido</span>
            </div>

        </div>
        <div class="input-container">
            <sca-text-field label="DNI">
              <input id="dni" scaNativeControl type="text" formControlName="dni" />
            </sca-text-field>
            <div *ngIf="form.controls['dni'].touched && form.controls['dni'].invalid">
                <span class="error" *ngIf="form.controls['dni'].errors?.['required']">DNI requerido</span>
                <span class="error" *ngIf="form.controls['dni'].errors?.['documentoInvalido']">DNI inválido</span>
            </div>
          </div>
          <div>

    <div class="input-container">
            <sca-text-field label="fechaNacimiento (DD/MM/YYYY)">
              <input id="fechaNacimiento" scaNativeControl formControlName="fechaNacimiento"/>
            </sca-text-field>
            <div *ngIf="form.controls['fechaNacimiento'].touched && form.controls['fechaNacimiento'].invalid">
                <span class="error" *ngIf="form.controls['fechaNacimiento'].errors?.['required']">Fecha requerida</span>
                <span class="error" *ngIf="form.controls['fechaNacimiento'].errors?.['fechaInvalida']">Formato de fecha inválido (DD/MM/YYYY)</span>
            </div>
          </div>
          
      
    </div>
    <div class="input-container">
      <sca-text-field label="Teléfono móvil">
        <input id="telefono" scaNativeControl type="text" formControlName="telefono" />
      </sca-text-field>
      <div *ngIf="form.controls['telefono'].touched && form.controls['telefono'].invalid">
        <span class="error" *ngIf="form.controls['telefono'].errors?.['required']">Teléfono requerido</span>
        <span class="error" *ngIf="form.controls['telefono'].errors?.['telefonoInvalido']">Teléfono móvil inválido</span>
      </div>
    </div>
          <button 
            sca-button
            variant="primary" 

            type="submit"
          >
            Validar
          </button>
          </form>
        
      </section>
      <section class="card">
        <h2>Validaciones disponibles</h2>
        <sca-alert variant="info" style="margin-bottom: 1.5rem;">
          <sca-icon icon="info" size="24px" [weight]="300" left />
          Validaciones proporcionadas por la librería <b>@argo/validation</b>
        </sca-alert>
        <table class="properties-table">
          <thead>
            <tr>
              <th>Validador</th>
              <th>Parámetros</th>
              <th>Error</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>validateEmail()</code></td>
              <td>-</td>
              <td><span class="value-enum">emailInvalido</span></td>
              <td>Valida el formato de un correo electrónico.</td>
            </tr>
            <tr>
              <td><code>validateDate(formato)</code></td>
              <td><code>'DD/MM/YYYY' | 'MM/DD/YYYY' | 'YYYY/MM/DD'</code></td>
              <td><span class="value-enum">fechaInvalida</span></td>
              <td>Valida el formato de una fecha según el formato indicado.</td>
            </tr>
            <tr>
              <td><code>validatePhone(tipo)</code></td>
              <td><code>'fijo' | 'movil' | 'generic'</code></td>
              <td><span class="value-enum">telefonoInvalido</span></td>
              <td>Valida el formato de un teléfono según el tipo especificado.</td>
            </tr>
            <tr>
              <td><code>validateDocument(tipo)</code></td>
              <td><code>'DNI' | 'NIE' | 'Pasaporte'</code></td>
              <td><span class="value-enum">documentoInvalido</span></td>
              <td>Valida el formato de un documento de identidad según el tipo.</td>
            </tr>
          </tbody>
        </table>
      </section>
</div>


